export default __webpack_public_path__ + "static/media/executive.689f7db2.png";